angular.module('app.api').factory('HidePositionEmployerApi', [
  'api',
  function HidePositionEmployerApi(api) {
    const hidePositionEmployerApi = {
      hideEmployer: (id, employerId) => {
        return api.post(`users/${id}/hidden/${employerId}`)
      },
      hidePosition: (id, positionId, reason) => {
        return api.post(
          `users/${id}/positions/hidden/${positionId}?reason=${reason}`
        )
      },
    }
    return hidePositionEmployerApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/modal-hide-positions-employer/hide-position-employer.api.js